export function App() {
  return (
    <main className="app-shell" aria-label="LOLO OPERATIONS">
      <section className="brand-lockup">
        <h1>LOLO OPERATIONS</h1>
        <p>LOLO COFFEE</p>
      </section>
    </main>
  );
}
